import {
    EXCLUDED_ATTRIBUTE_ADDRESS_FIELDS_IDS
} from "@constants/self-service-constants";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { AttributeTypeFieldsMap } from "@idw-types/data/reference-data/generic/attribute-type-fields-map";

export const getAxnAttributeTypeFieldMapWithoutSelfServiceCheck = (axnAttributeTypeFields: Array<AxnAttributeTypeField>) => {
    return axnAttributeTypeFields.reduce((attributeTypeFieldsMap, attributeTypeField) => {
            if (!attributeTypeFieldsMap[attributeTypeField.attributeTypeID]) {
                attributeTypeFieldsMap[attributeTypeField.attributeTypeID] = [];
            }

            if(!EXCLUDED_ATTRIBUTE_ADDRESS_FIELDS_IDS.includes(attributeTypeField.id)) {
                attributeTypeFieldsMap[attributeTypeField.attributeTypeID].push(attributeTypeField);
            }
        

        return attributeTypeFieldsMap;
    }, {} as AttributeTypeFieldsMap);
}